import { Injectable, inject } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { ActivatedRouteSnapshot, RouterStateSnapshot, TitleStrategy } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { environment } from "~environments/environment";

@Injectable()
export class EnvironmentTitleStrategy extends TitleStrategy {
    skipEnvironmentTitleStrategyForRoute = false;

    private readonly title = inject(Title);
    private readonly translateService = inject(TranslateService);

    override getResolvedTitleForRoute(snapshot: ActivatedRouteSnapshot) {
        this.skipEnvironmentTitleStrategyForRoute = !!snapshot.data.skipEnvironmentTitleStrategyForRoute;
        return super.getResolvedTitleForRoute(snapshot);
    }

    override updateTitle(routerState: RouterStateSnapshot) {
        // Kör buildTitle tidigt för att uppdatera skip flaggan
        const title = this.buildTitle(routerState);
        if (this.skipEnvironmentTitleStrategyForRoute) {
            return;
        }

        const env = environment.environment !== "PROD" ? this.translateService.instant(environment.environment) : "";

        if (title !== undefined) {
            this.title.setTitle(`${title} - RASK ${env}`);
        } else {
            this.title.setTitle(`RASK ${env}`);
        }
    }
}
